import { Box, Flex, Text } from '@radix-ui/themes';
import { Gauge } from 'lucide-react';
import type { CodexUsage } from '@mac-remote/protocol';
import { primaryLimit, untilReset, usedColor } from '../lib/codexLimits';
import { Bar } from './CodexLimits';

/** The main Codex usage window, with other windows available in the full panel. */
export function CodexSession({ usage, onClick }: { usage: CodexUsage | null; onClick: () => void }) {
  const limit = usage?.ok ? primaryLimit(usage) : null;
  const reset = limit ? untilReset(limit.resetsAt, Date.now()) : null;
  const color = limit ? usedColor(limit.used) : 'jade';

  return (
    <button
      onClick={onClick}
      style={{
        display: 'block',
        width: '100%',
        border: 0,
        borderRadius: 10,
        padding: '9px 12px',
        background: 'var(--app-secondary-bg)',
        color: 'var(--app-text)',
        font: 'inherit',
        textAlign: 'left',
        cursor: 'pointer',
      }}
    >
      <Flex align="center" gap="2">
        <Gauge size={15} style={{ color: 'var(--app-hint)', flex: '0 0 auto' }} />
        <Text size="2" style={{ flex: 1, minWidth: 0 }}>
          {limit ? limit.title : 'Лимиты Codex'}
        </Text>
        {limit ? (
          <Text size="2" weight="bold" style={{ flex: '0 0 auto', color: `var(--${color}-11)` }}>
            {Math.round(limit.used)}%
          </Text>
        ) : (
          <Text size="1" style={{ flex: '0 0 auto', color: 'var(--app-hint)' }}>
            нет данных
          </Text>
        )}
      </Flex>

      {limit ? (
        <>
          <Box style={{ margin: '7px 0 4px' }}>
            <Bar used={limit.used} color={color} />
          </Box>
          <Text size="1" style={{ color: 'var(--app-hint)' }}>
            использовано{reset ? ` · сброс ${reset}` : ''}
          </Text>
        </>
      ) : (
        <Text size="1" as="p" style={{ color: 'var(--app-hint)', margin: '4px 0 0' }}>
          {usage && !usage.ok ? usage.error : 'мак не на связи — лимиты читаются с него'}
        </Text>
      )}
    </button>
  );
}
